import React, { useEffect, useMemo } from "react";
import { Grid, Typography } from "@material-ui/core";
import isEmpty from "lodash/isEmpty";
import moment from "moment";

import { BootstrapTooltip } from "../../../../components/molecules/tooltip";
import topAdBadge from "../../../../../images/topad-badge.png";
import { useTranslation } from "react-i18next";
import RepublishedIcon from "../../../../../images/republished-arrow.png";

const CardFooter = ({ advertisment, isFeatured, position }) => {
  const { t } = useTranslation();

  const isRepublishedAd = useMemo(() => {
    if (
      isEmpty(advertisment.publishedAt) ||
      isEmpty(advertisment.republishedAt)
    ) {
      return false;
    }
    const publishedAt = moment(advertisment.publishedAt).startOf("day");
    const republishedAt = moment(advertisment.republishedAt).startOf("day");
    return publishedAt.isBefore(republishedAt);
  }, [advertisment]);

  const publishedText = useMemo(() => {
    const formattingDate = isRepublishedAd
      ? advertisment.republishedAt
      : advertisment.publishedAt;
    let output = isRepublishedAd ? "Republished" : "Published";
    output += ` ${moment.utc(formattingDate).local().fromNow()}`;
    return output;
  }, [advertisment.publishedAt, advertisment.republishedAt, isRepublishedAd]);

  return (
    <Grid container direction="row" justifyContent="space-between">
      <Grid
        container
        direction="row"
        xs
        alignItems="center"
        className="column-gap-4"
      >
        {isFeatured && (
          <img
            src={topAdBadge}
            alt="top-ad-badge"
            className="top-ad-badge"
            title="Boost Ad"
          />
        )}
        <BootstrapTooltip title={t("common.publishedDate")}>
          <Typography className="published-time-txt">
            {publishedText}
          </Typography>
        </BootstrapTooltip>
        {isRepublishedAd && (
          <img src={RepublishedIcon} alt="republished" style={{ width: 12 }} />
        )}
      </Grid>
      <Typography
        className="see-more-txt"
        id={position === 1 ? "more-one" : null}
      >{`${t("common.moreDetails")} >`}</Typography>
    </Grid>
  );
};
export default CardFooter;
